import React, { FC } from 'react';
import { Driver } from '../../types/driver.types';

interface DriverListProps {
  drivers: Driver[];
  selectedDriver: string | null;
  onDriverSelect: (driverId: string) => void;
  onDriverStatusToggle: (driverId: string) => void;
  onDriverEdit: (driver: Driver) => void;
}

export const DriverList: FC<DriverListProps> = ({
  drivers,
  selectedDriver,
  onDriverSelect,
  onDriverStatusToggle,
  onDriverEdit
}) => {
  console.log('DriverList rendered with drivers:', drivers);
  return (
    <div className="bg-white rounded-lg shadow-md p-4">
      <h2 className="text-xl font-semibold mb-4">Driver List</h2>
      <div className="space-y-3 max-h-96 overflow-y-auto">
        {drivers.map(driver => (
          <div 
            key={driver.id} 
            className={`p-3 border rounded-lg transition-colors cursor-pointer ${
              selectedDriver === driver.id ? 'border-blue-500 bg-blue-50' : 'border-gray-200'
            } ${!driver.active ? 'opacity-50' : ''}`}
            onClick={() => onDriverSelect(driver.id)}
          >
            <div className="flex justify-between items-start">
              <div className="flex-1">
                <h3 className="font-semibold">{driver.name}</h3>
                <p className="text-sm text-gray-600">{driver.vehicleId}</p>
                <p className="text-xs text-gray-500">{driver.email}</p>
              </div>
              <div className="flex items-center space-x-2">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onDriverEdit(driver);
                  }}
                  className="text-blue-600 hover:text-blue-800 transition-colors"
                  title="Edit Driver"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                  </svg>
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onDriverStatusToggle(driver.id);
                  }}
                  className={`transition-colors ${
                    driver.active ? 'text-green-600 hover:text-green-800' : 'text-red-600 hover:text-red-800'
                  }`}
                  title={driver.active ? 'Active' : 'Inactive'}
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" 
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" 
                      clipRule="evenodd" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};